import React from 'react';
import classNames from 'classnames';

import useBem from '@/use/useBem';
import useLayout from '@/use/useLayout';
import useBoardSide from '@/use/useBoardSide';

type Props = {
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  onClick?(): void;
};
const Centered = ({
  children,
  className = '',
  contentClassName,
  ...rest
}: Props) => {
  const { layout } = useLayout();
  const { bem } = useBem('centered');
  const boardSide = useBoardSide();

  const padding = layout === 'landscape' ? boardSide.width : undefined;

  return (
    <div
      className={classNames([bem('', layout), className])}
      {...rest}
      style={{ paddingLeft: padding, paddingRight: padding }}
    >
      <div className={bem('wrap')}>
        <div
          className={classNames([bem('content'), contentClassName])}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Centered;
